var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIkona(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Facebook",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.7 65.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010002;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook_ikona") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.3-65.6A32.86,32.86,0,0,0,48.4-32.7,32.9,32.9,0,0,0,75.8-.3V-25.8H67.9V-35h7.9v-6.8c0-7.9,4.8-12.2,11.8-12.2a63.44,63.44,0,0,1,7.1.4v8.2H89.8c-3.8,0-4.6,1.8-4.6,4.5V-35h9.1l-1.2,9.2H85.2V0a32.89,32.89,0,0,0,28.9-32.7A32.84,32.84,0,0,0,81.3-65.6Z",
    transform: "translate(-48.4 65.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIkona);
export default __webpack_public_path__ + "static/media/facebook_ikona.9ea4d3c50abda6cc0e7886bb4a499016.svg";
export { ForwardRef as ReactComponent };